<ui-simple-dialog #dialog closedby="none">
  <div
    class="self-stretch justify-center text-on-surface dark:text-on-surface-darkmode text-2xl font-semibold leading-8 line-clamp-1"
  >
    <!-- title -->
    <h1>{{ 'demoMode.cookieBanner.title' | transloco }}</h1>
  </div>
  <div class="pt-8 pb-12 text-on-surface dark:text-on-surface-darkmode">
    <!-- content -->
    <div class="flex flex-col gap-5">
      <div
        class="flex flex-col gap-2 text-sm text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
      >
        <p>
          {{ 'demoMode.cookieBanner.intro' | transloco }}
          {{ 'demoMode.cookieBanner.registerPrefix' | transloco }}
          <a
            [href]="registerLumoUrl"
            target="_blank"
            class="text-primary dark:text-primary-darkmode hover:underline font-medium"
            >{{ 'demoMode.cookieBanner.registerLink' | transloco }}</a
          >{{ 'demoMode.cookieBanner.registerSuffix' | transloco }}
          <a
            [href]="links.lumo"
            target="_blank"
            class="text-primary dark:text-primary-darkmode hover:underline font-medium"
            >{{ 'demoMode.cookieBanner.lumoLink' | transloco }}</a
          >.
        </p>
        <p class="text-xs text-on-surface-variant dark:text-on-surface-variant-darkmode">
          {{ 'demoMode.cookieBanner.legalNotice' | transloco }}
          <a
            [href]="links.privacy"
            target="_blank"
            class="text-primary dark:text-primary-darkmode hover:underline"
            >{{ 'demoMode.cookieBanner.privacyLink' | transloco }}</a
          >
          {{ 'demoMode.cookieBanner.and' | transloco }}
          <a
            [href]="links.imprint"
            target="_blank"
            class="text-primary dark:text-primary-darkmode hover:underline"
            >{{ 'demoMode.cookieBanner.imprintLink' | transloco }}</a
          >.
        </p>
      </div>

      <div>
        <h2 class="text-xl font-semibold">
          {{ 'demoMode.cookieBanner.settingsTitle' | transloco }}
        </h2>

        <app-user-settings-form />
      </div>
    </div>
  </div>
  <div class="flex flex-col sm:flex-row sm:justify-end w-full gap-3">
    <!-- footer -->
    <ui-button mode="outlined" (click)="onClickDecline()">
      {{ 'demoMode.cookieBanner.declineButton' | transloco }}
    </ui-button>
    <ui-button (click)="onClickConfirm()">
      {{ 'demoMode.cookieBanner.confirmButton' | transloco }}
    </ui-button>
  </div>
</ui-simple-dialog>
